import React, { useEffect, useState, useCallback } from "react";
import { useForm, FormProvider } from "react-hook-form";
//Material
import { Button } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
//Component
import { ReactTable } from "../../stories/react-table";
import { BaseContainer } from "../../stories/base-container";
import { BoxTemplate1 } from "../../stories/Box";
import { makeStyles } from "@material-ui/core/styles";
//Function
import { getMasterTemplateColumns } from "./columns/master-template";
import { GetUser } from "../../utils/sessions";
import { useSelectRowOpenModal } from "../function-api/useSelectRowOpenModal";
import MasterTemplateImportModal from "./modal/master-template-import";
import MasterTemplateHistoryModal from "./modal/master-template-import-history";
import * as api from "./api";
import * as alertDialog from "../../utils/alert";

const useStyles = makeStyles((theme) => ({
  rootSearch: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    width: 400,
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButtonX: {
    padding: 10,
  },
  iconButton: {
    backgroundColor: "#000",
    color: "#fff",
  },
  iconButtonAddDelete: {
    backgroundColor: "#000",
    color: "#fff",
    marginRight: theme.spacing(2),
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

const rowStyle = (row, rowIndex) => {
  return { backgroundColor: row.STATUS_COLOR };
};

function ConfigMasterTemplate() {
  //State
  const methodForm = useForm();
  const { register, getValues } = methodForm;
  const [editMode, setEditMode] = useState(false);

  const {
    isOpen: openMasterTemplateModal,
    onOpen: onOpeneMasterTemplate,
    onClose: onCloseMasterTemplate,
    Data: selectedTemplate,
    handleClickRow: onClickRow,
  } = useSelectRowOpenModal();

  const [DataList, setDataList] = useState([]);
  const [historyList, setHistoryList] = useState([]);

  const [openHistoryModal, setOpenHistoryModal] = useState(false);

  const classes = useStyles();
  const fetch = useCallback(async () => {
    setDataList([]);
    const param = {
      TEXT_SEARCH: getValues()?.TEXT_SEARCH,
      USER_ID: GetUser(),
      MODE: "Refresh",
    };
    const res = await api.GetListConfigMasterTemplate(param);
    setDataList(res);
  }, [getValues]);

  //Effect
  useEffect(() => {
    fetch();
  }, [fetch]);

  const onDeleteTemplate = async (TEMPLATE_ID) => {
    let res = await alertDialog.ConfirmDelete();
    if (!res) return;

    let param = {
      TEMPLATE_ID: TEMPLATE_ID,
    };

    let api_res = await api.DeleteConfigMasterTemplate(param);
    if (!api_res) return;
    fetch();
    alertDialog.del_success();
  };

  const onEditTemplate = (row) => {
    setEditMode(true);
    onClickRow(row);
  };

  const onViewHistory = (row) => {
    const fetchHistory = async () => {
      let param = { TEMPLATE_ID: row.TEMPLATE_ID };
      let res = await api.GetListViewUploadTemplateHistory(param);
      setHistoryList(res);
    };
    fetchHistory();
    setOpenHistoryModal(true);
  };

  const onCloseViewHistory = () => {
    setOpenHistoryModal(false);
  };

  const onHandleEnter = (e) => {
    if (e.keyCode === 13) {
      onSearchText();
      e.preventDefault();
    }
  };

  const onSearchText = async () => {
    fetch();
  };

  const tablecomponent = () => {
    return (
      <>
        <Button
          className={classes.iconButtonAddDelete}
          variant="contained"
          onClick={() => {
            setEditMode(false);
            onOpeneMasterTemplate();
          }}
        >
          Add Template
        </Button>
      </>
    );
  };

  const searchcomponent = (searchProps) => {
    return (
      <>
        <Paper component="form" className={classes.rootSearch}>
          <InputBase
            className={classes.input}
            placeholder="Search"
            inputProps={{ "aria-label": "search" }}
            name="TEXT_SEARCH"
            inputRef={register}
            onKeyDown={(e) => onHandleEnter(e)}
          />
          <Divider className={classes.divider} orientation="vertical" />
          <Button
            variant="contained"
            className={classes.iconButton}
            onClick={onSearchText}
          >
            Search
          </Button>
        </Paper>
      </>
    );
  };

  return (
    <div>
      <BaseContainer maxWidth={false}>
        <BoxTemplate1 height="80vh" title="Config master template">
          <FormProvider {...methodForm}>
            <ReactTable
              keyField="TEMPLATE_ID"
              data={DataList}
              columns={getMasterTemplateColumns(
                onDeleteTemplate,
                onEditTemplate,
                onViewHistory
              )}
              headcomponent={tablecomponent}
              showSearch={false}
              headRightcomponent={searchcomponent}
              rowStyle={rowStyle}
            />
          </FormProvider>
        </BoxTemplate1>
        <MasterTemplateImportModal
          disableBackdropClick={true}
          open={openMasterTemplateModal}
          onClose={onCloseMasterTemplate}
          data={selectedTemplate}
          editmode={editMode ? 1 : 0}
          fetchmain={fetch}
        />
        <MasterTemplateHistoryModal
          open={openHistoryModal}
          onClose={onCloseViewHistory}
          datalist={historyList}
        />
      </BaseContainer>
    </div>
  );
}
export default ConfigMasterTemplate;
